import styled from 'styled-components';
import Layout from 'antd/lib/layout/layout';

export const MainStyled = styled(Layout)`
  min-height: 100vh;

  .ant-layout-content {
    padding: 20px 40px;
  }
`;
